<script setup lang="ts">
  // function handleOpenWangAn(){
  //   window.open(`https://beian.mps.gov.cn/#/query/webSearch`, '_blank ')
  // }

</script>
<template>
  <div class="default-footer">
      <div class="industry">
        <div class="icp">
          增值电信业务经营许可证编号：粤B2-20240138
          <!-- <div style="text-align: center;display: flex;align-items: center;margin-left: 30px;cursor: pointer;" @click="handleOpenWangAn">
            <img src="https://static.xmjishou.com/xianmao/web/index/police.png" style="margin-right: 5px;"  alt="">
            <a style="color: #fff;text-decoration: none;"
            rel="noreferrer" target="_blank">粤公网安备44010602014203号</a></div> -->
        </div>
        <ElRow :gutter="120">
          <ElCol :span="4">
            <div class="grid-content">
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">
                <img style="width: 160px;height: 55px;" src="https://static.xmjishou.com/xianmao/web/index/ftlink2.png"
                  alt="工信部 ICP域名备案"></img>
              </a>
            </div>
          </ElCol>
          <ElCol :span="4">
            <div class="grid-content">
              <a href="https://cyberpolice.mps.gov.cn/wfjb/#/" target="_blank">
                <img style="width: 160px;height: 55px;" src="https://static.xmjishou.com/xianmao/web/index/ftlink3.png"
                  alt="网络违法犯罪举报中心"></img>
              </a>
            </div>
          </ElCol>
          <ElCol :span="4">
            <div class="grid-content">
              <a href="https://www.12377.cn/" target="_blank">
                <img style="width: 160px;height: 55px;" src="https://static.xmjishou.com/xianmao/web/index/ftlink4.png"
                  alt="不良信息举报中心"></img>
              </a>
            </div>
          </ElCol>
          <ElCol :span="4">
            <div class="grid-content">
              <a href="https://www.bidchance.com/company-381935.html" target="_blank">
                <img style="width: 160px;height: 55px;" src="https://static.xmjishou.com/xianmao/web/index/ftlink5.png"
                  alt="广东省工商行政管理局"></img>
              </a>
            </div>
          </ElCol>
          <ElCol :span="4">
            <div class="grid-content">
              <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank">
                <img style="width: 160px;height: 55px;" src="https://static.xmjishou.com/xianmao/web/index/ftlink6.png"
                  alt="全国互联网安全管理服务平台"></img>
              </a>
            </div>
          </ElCol>
        </ElRow>
        <div style="text-align: center;padding: 0px 0 40px;">
          <a style="text-decoration: none;color: #fff;"
            href="https://beian.miit.gov.cn/#/Integrated/index">Copyright © 闲猫科技. All Rights Reserved 粤ICP备2023072473号</a>
        </div>
      </div>
  </div>
</template>
<style lang="scss" scoped>
.default-footer {
  color: #FFFFFF;
  background-color: #031326;
  width: 100%;

  .industry {
    width: 960px;
    margin: 0 auto 0px;
    padding-top: 30px;

    .icp {
      margin-bottom: 20px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .grid-content {
      width: 200px;
      height: 69px;
      border-radius: 0px 0px 0px 0px;
    }
  }
}

</style>
